// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6313922b","147":"f62c9027","448":"6a19a83a","574":"6c85020d","615":"93bf095a","807":"598065bb","818":"18b98de6","899":"d0c758f6","900":"815301c4"}[chunkId] + ".chunk.js";
};